(function () {
  'use strict';

  /* @ngdoc object
   * @name trainingCostReport
   * @description
   *
   */
  angular
    .module('trainingCostReport', [
      'ui.router'
    ]);
}());
